import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useConfig } from 'providers';
import { useCallback } from 'react';
import useAccessToken from '../useAccessToken';

interface UploadFileMutationProps {
  formData: FormData;
}

export const useUploadFileMutation = ({ formData }: UploadFileMutationProps) => {
  const { data: accessToken } = useAccessToken();
  const { mdcFullApiUrl } = useConfig();

  const uploadFile = useCallback(async () => {
    const response = await axios({
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'post',
      url: `${mdcFullApiUrl}files`,
      data: formData,
    });
    return response.data;
  }, [accessToken, formData, mdcFullApiUrl]);

  return useMutation({
    mutationKey: ['uploadFile'],
    mutationFn: uploadFile,
  });
};
